import { render, staticRenderFns } from "./CustomerDashboard.vue?vue&type=template&id=e486b19e"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js"
import style0 from "./CustomerDashboard.vue?vue&type=style&index=0&id=e486b19e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports